import { mapState } from "vuex";

export default {
    data() {
        return {
            activeTab: "",
        };
    },
    beforeMount() {
        this.setPageLoaded(this.$route.name.toString().toLowerCase());
    },
    mounted() {
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', '/static/assets/js/scripts.bundle.js')
        document.head.appendChild(externalScript)
    },
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            userProfileLoaded: state => state.userProfileLoaded,
            currentUser: state => state.currentUser,
        }),
    },
    methods: {
        setPageLoaded(page) {
            this.activeTab = page;
        },
        openUrl(url) {
            window.open(url);
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/global/components/nav-bar/nav-bar.js